import {ApiModel} from '@models/api-model';
import {UserNamespace} from '@namespaces/user.namespace';

export class User extends ApiModel<UserNamespace.UserApiInterface> {
    id: number;
    name: string;

    constructor(_rawData) {
        super(_rawData);
        this.setAttributes();
    }

    setAttributes() {
        this.id = this.rawData.id;
        this.name = this.rawData.username;
    }

    hasPermissions(permissions: UserNamespace.Permission[] = []): boolean {
        return permissions.every(permission => this.rawData.permissions.includes(permission));
    }
}
